export class GAClient {
    constructor(config) {
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.config = config;
    }
    // GTMのトリガーに設定しているカスタムイベントを送っている
    pushEvent(eventName, params = {}) {
        window.dataLayer && window.dataLayer.push(Object.assign({ event: eventName }, params));
    }
    trackConversionGTM(userId, campaignCode) {
        this.pushEvent('cc_register', {
            registration_user_id: userId,
            registration_campaign_code: campaignCode || '',
        });
    }
    trackDiagnosisStart() {
        this.pushEvent('diagnosis_start');
    }
    trackDiagnosisComplete() {
        this.pushEvent('diagnosis_complete');
    }
    trackDiagnosisPlanGenerated() {
        this.pushEvent('diagnosis_plan_generated');
    }
    trackDiagnosisCCView() {
        this.pushEvent('diagnosis_cc_view');
    }
}
